// Code generated by Wire protocol buffer compiler, do not edit.
// Source: vreo.volt.protocol.TelemetryType in anprMessage/anprMessage.proto
@file:Suppress(
  "DEPRECATION",
  "RUNTIME_ANNOTATION_NOT_SUPPORTED",
)

package vreo.volt.protocol

import com.squareup.wire.FieldEncoding
import com.squareup.wire.Message
import com.squareup.wire.ProtoAdapter
import com.squareup.wire.ProtoReader
import com.squareup.wire.ProtoWriter
import com.squareup.wire.ReverseProtoWriter
import com.squareup.wire.Syntax.PROTO_3
import com.squareup.wire.WireField
import com.squareup.wire.`internal`.JvmField
import kotlin.Any
import kotlin.AssertionError
import kotlin.Boolean
import kotlin.Deprecated
import kotlin.DeprecationLevel
import kotlin.Float
import kotlin.Int
import kotlin.Long
import kotlin.Nothing
import kotlin.String
import kotlin.Suppress
import okio.ByteString

/**
 * Telemetry type, represents device's telemetry readings.
 *
 * @property cpu_usage CPU usage as percentage
 * @property cpu_temperature CPU temperature in degrees celsius
 * @property ram_usage RAM usage as percentage
 * @property enclosure_temperature Enclosure temperature in degrees celsius
 * @property enclosure_pressure Enclosure pressure in hPa
 * @property enclosure_humidity Enclosure humidity in percent
 * @property time_stamp Telemetry unix timestamp in seconds
 */
public class TelemetryType(
  @field:WireField(
    tag = 1,
    adapter = "com.squareup.wire.ProtoAdapter#FLOAT",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "cpuUsage",
    schemaIndex = 0,
  )
  public val cpu_usage: Float = 0f,
  @field:WireField(
    tag = 2,
    adapter = "com.squareup.wire.ProtoAdapter#FLOAT",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "cpuTemperature",
    schemaIndex = 1,
  )
  public val cpu_temperature: Float = 0f,
  @field:WireField(
    tag = 3,
    adapter = "com.squareup.wire.ProtoAdapter#FLOAT",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "ramUsage",
    schemaIndex = 2,
  )
  public val ram_usage: Float = 0f,
  @field:WireField(
    tag = 4,
    adapter = "com.squareup.wire.ProtoAdapter#FLOAT",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "enclosureTemperature",
    schemaIndex = 3,
  )
  public val enclosure_temperature: Float = 0f,
  @field:WireField(
    tag = 5,
    adapter = "com.squareup.wire.ProtoAdapter#FLOAT",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "enclosurePressure",
    schemaIndex = 4,
  )
  public val enclosure_pressure: Float = 0f,
  @field:WireField(
    tag = 6,
    adapter = "com.squareup.wire.ProtoAdapter#FLOAT",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "enclosureHumidity",
    schemaIndex = 5,
  )
  public val enclosure_humidity: Float = 0f,
  @field:WireField(
    tag = 7,
    adapter = "com.squareup.wire.ProtoAdapter#INT64",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "timeStamp",
    schemaIndex = 6,
  )
  public val time_stamp: Long = 0L,
  unknownFields: ByteString = ByteString.EMPTY,
) : Message<TelemetryType, Nothing>(ADAPTER, unknownFields) {
  @Deprecated(
    message = "Shouldn't be used in Kotlin",
    level = DeprecationLevel.HIDDEN,
  )
  override fun newBuilder(): Nothing = throw AssertionError("Builders are deprecated and only available in a javaInterop build; see https://square.github.io/wire/wire_compiler/#kotlin")

  override fun equals(other: Any?): Boolean {
    if (other === this) return true
    if (other !is TelemetryType) return false
    if (unknownFields != other.unknownFields) return false
    if (cpu_usage != other.cpu_usage) return false
    if (cpu_temperature != other.cpu_temperature) return false
    if (ram_usage != other.ram_usage) return false
    if (enclosure_temperature != other.enclosure_temperature) return false
    if (enclosure_pressure != other.enclosure_pressure) return false
    if (enclosure_humidity != other.enclosure_humidity) return false
    if (time_stamp != other.time_stamp) return false
    return true
  }

  override fun hashCode(): Int {
    var result = super.hashCode
    if (result == 0) {
      result = unknownFields.hashCode()
      result = result * 37 + cpu_usage.hashCode()
      result = result * 37 + cpu_temperature.hashCode()
      result = result * 37 + ram_usage.hashCode()
      result = result * 37 + enclosure_temperature.hashCode()
      result = result * 37 + enclosure_pressure.hashCode()
      result = result * 37 + enclosure_humidity.hashCode()
      result = result * 37 + time_stamp.hashCode()
      super.hashCode = result
    }
    return result
  }

  override fun toString(): String {
    val result = mutableListOf<String>()
    result += """cpu_usage=$cpu_usage"""
    result += """cpu_temperature=$cpu_temperature"""
    result += """ram_usage=$ram_usage"""
    result += """enclosure_temperature=$enclosure_temperature"""
    result += """enclosure_pressure=$enclosure_pressure"""
    result += """enclosure_humidity=$enclosure_humidity"""
    result += """time_stamp=$time_stamp"""
    return result.joinToString(prefix = "TelemetryType{", separator = ", ", postfix = "}")
  }

  public fun copy(
    cpu_usage: Float = this.cpu_usage,
    cpu_temperature: Float = this.cpu_temperature,
    ram_usage: Float = this.ram_usage,
    enclosure_temperature: Float = this.enclosure_temperature,
    enclosure_pressure: Float = this.enclosure_pressure,
    enclosure_humidity: Float = this.enclosure_humidity,
    time_stamp: Long = this.time_stamp,
    unknownFields: ByteString = this.unknownFields,
  ): TelemetryType = TelemetryType(cpu_usage, cpu_temperature, ram_usage, enclosure_temperature, enclosure_pressure, enclosure_humidity, time_stamp, unknownFields)

  public companion object {
    @JvmField
    public val ADAPTER: ProtoAdapter<TelemetryType> = object : ProtoAdapter<TelemetryType>(
      FieldEncoding.LENGTH_DELIMITED, 
      TelemetryType::class, 
      "type.googleapis.com/vreo.volt.protocol.TelemetryType", 
      PROTO_3, 
      null, 
      "anprMessage/anprMessage.proto"
    ) {
      override fun encodedSize(`value`: TelemetryType): Int {
        var size = value.unknownFields.size
        if (!value.cpu_usage.equals(0f)) {
          size += ProtoAdapter.FLOAT.encodedSizeWithTag(1, value.cpu_usage)
        }
        if (!value.cpu_temperature.equals(0f)) {
          size += ProtoAdapter.FLOAT.encodedSizeWithTag(2, value.cpu_temperature)
        }
        if (!value.ram_usage.equals(0f)) {
          size += ProtoAdapter.FLOAT.encodedSizeWithTag(3, value.ram_usage)
        }
        if (!value.enclosure_temperature.equals(0f)) {
          size += ProtoAdapter.FLOAT.encodedSizeWithTag(4, value.enclosure_temperature)
        }
        if (!value.enclosure_pressure.equals(0f)) {
          size += ProtoAdapter.FLOAT.encodedSizeWithTag(5, value.enclosure_pressure)
        }
        if (!value.enclosure_humidity.equals(0f)) {
          size += ProtoAdapter.FLOAT.encodedSizeWithTag(6, value.enclosure_humidity)
        }
        if (value.time_stamp != 0L) {
          size += ProtoAdapter.INT64.encodedSizeWithTag(7, value.time_stamp)
        }
        return size
      }

      override fun encode(writer: ProtoWriter, `value`: TelemetryType) {
        if (!value.cpu_usage.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 1, value.cpu_usage)
        }
        if (!value.cpu_temperature.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 2, value.cpu_temperature)
        }
        if (!value.ram_usage.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 3, value.ram_usage)
        }
        if (!value.enclosure_temperature.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 4, value.enclosure_temperature)
        }
        if (!value.enclosure_pressure.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 5, value.enclosure_pressure)
        }
        if (!value.enclosure_humidity.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 6, value.enclosure_humidity)
        }
        if (value.time_stamp != 0L) {
          ProtoAdapter.INT64.encodeWithTag(writer, 7, value.time_stamp)
        }
        writer.writeBytes(value.unknownFields)
      }

      override fun encode(writer: ReverseProtoWriter, `value`: TelemetryType) {
        writer.writeBytes(value.unknownFields)
        if (value.time_stamp != 0L) {
          ProtoAdapter.INT64.encodeWithTag(writer, 7, value.time_stamp)
        }
        if (!value.enclosure_humidity.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 6, value.enclosure_humidity)
        }
        if (!value.enclosure_pressure.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 5, value.enclosure_pressure)
        }
        if (!value.enclosure_temperature.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 4, value.enclosure_temperature)
        }
        if (!value.ram_usage.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 3, value.ram_usage)
        }
        if (!value.cpu_temperature.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 2, value.cpu_temperature)
        }
        if (!value.cpu_usage.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 1, value.cpu_usage)
        }
      }

      override fun decode(reader: ProtoReader): TelemetryType {
        var cpu_usage: Float = 0f
        var cpu_temperature: Float = 0f
        var ram_usage: Float = 0f
        var enclosure_temperature: Float = 0f
        var enclosure_pressure: Float = 0f
        var enclosure_humidity: Float = 0f
        var time_stamp: Long = 0L
        val unknownFields = reader.forEachTag { tag ->
          when (tag) {
            1 -> cpu_usage = ProtoAdapter.FLOAT.decode(reader)
            2 -> cpu_temperature = ProtoAdapter.FLOAT.decode(reader)
            3 -> ram_usage = ProtoAdapter.FLOAT.decode(reader)
            4 -> enclosure_temperature = ProtoAdapter.FLOAT.decode(reader)
            5 -> enclosure_pressure = ProtoAdapter.FLOAT.decode(reader)
            6 -> enclosure_humidity = ProtoAdapter.FLOAT.decode(reader)
            7 -> time_stamp = ProtoAdapter.INT64.decode(reader)
            else -> reader.readUnknownField(tag)
          }
        }
        return TelemetryType(
          cpu_usage = cpu_usage,
          cpu_temperature = cpu_temperature,
          ram_usage = ram_usage,
          enclosure_temperature = enclosure_temperature,
          enclosure_pressure = enclosure_pressure,
          enclosure_humidity = enclosure_humidity,
          time_stamp = time_stamp,
          unknownFields = unknownFields
        )
      }

      override fun redact(`value`: TelemetryType): TelemetryType = value.copy(
        unknownFields = ByteString.EMPTY
      )
    }

    private const val serialVersionUID: Long = 0L
  }
}
